import React, { useEffect, useState } from 'react';
import { Card, CardContent, Typography, Button, useMediaQuery, FormControlLabel, RadioGroup, Radio, FormLabel, FormControl } from '@mui/material';
import { AddShoppingCart } from '@mui/icons-material';
import './smartphone.css'
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import ShoppingBasketIcon from '@mui/icons-material/ShoppingBasket';
import { Image } from 'cloudinary-react'
import { addToCart } from '../../../../features/slices/cartSlice';
import { useGetAllColorsQuery, useGetAllSmartphonesQuery, useGetCartQuery, useUpdateCartMutation } from '../../../../features/fullApi';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { styled } from '@mui/material/styles';
import { toast } from 'react-hot-toast';
import ClipLoader from 'react-spinners/ClipLoader';
import RelatedProductsSlider from './RelatedProductsSlider';
import { RelatedProducts } from '@algolia/recommend-react';


const Root = styled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    typography: {
      fontSize: 12,
    },
    padding: theme.spacing(3),
  },
  [theme.breakpoints.up('md')]: {
    typography: {
      fontSize: 20,
    },
    padding: theme.spacing(5),
  },
  [theme.breakpoints.up('lg')]: {
    typography: {
      fontSize: 22,
    },
    padding: theme.spacing(7),
  },
}));



const GetProduct = ({onAddToCart}) => {

  const navigate = useNavigate()
  const [product, setProduct] = useState({})
  const dispatch = useDispatch()
  const user = JSON.parse(localStorage.getItem('user'))

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [])

  
  const [updateCart] = useUpdateCartMutation()

  const {data: cart, error: cartError, isLoading: cartIsLoading} = useGetCartQuery(user?._id);

  const theme = useTheme()

  const params = useParams();
  const productID =  params.id
  const queryID = params.queryID

  const isXs= useMediaQuery(theme.breakpoints.down('xs'));
  const isSm= useMediaQuery(theme.breakpoints.down('sm'));
  const isMd= useMediaQuery(theme.breakpoints.down('md'));
  const isLg= useMediaQuery(theme.breakpoints.down('lg'));
  const isXl= useMediaQuery(theme.breakpoints.down('xl'));

  const [value, setValue] = useState("")

  const {data, error, isLoading} = useGetAllSmartphonesQuery();

  const {data: colors, error: colorsError, isLoading: isLoadingColors} = useGetAllColorsQuery()

    //constructing the boolean colors checked array
    const [colorsObj, setColorsObj] = useState({})

   const [fshd, setFshd] = useState(false)


    useEffect(() => {
      if(!isLoadingColors) {
        Object.keys(colors).forEach(ele => {
          let key = colors[ele]._id
          let value = colors[ele].colorName
            colorsObj[key] = value;
        });
        setFshd(true)

      }
    }, [colors, isLoadingColors])
  
  useEffect(() => {
    setValue(colorsObj[product.colorId])
  }, [fshd])




  let prodData
  const getProduct = async (productId) => {
    prodData = await axios.get(`${process.env.REACT_APP_BACKEND_API_URL}/api/smartphones/find/${productId}`)
    .then(res => {
      setValue(colorsObj[res.data.colorId])
      setProduct(res.data)
      }
    )
    .catch(err => console.log(err))
  };

  useEffect(() => {
    console.log("params id", params.id)
    getProduct(params.id);
  }, [params.id]);

  useEffect(() => {
    console.log("PRODUCTS DATA", data)
    getProductsByGroup()
  }, [data]);


  const getProductsByGroup = async () => {
    if(!isLoading) {
      const filtered = data?.filter(prod => {
        return prod.groupId === product.groupId;
      });
    }
  }

  const changeProduct = async (prodId) => {
    console.log(prodId);
    getProduct(prodId)
  }

  const cartLs = useSelector(state => state.cart)



  const handleAddToCart = (product) => {
    if(user?.accessToken && cart?._id) {
      let cartProduct = cartLs.cartItems.filter(function (el)
      {
        return el._id === product._id
      })

      if(cartProduct.length === 0) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        console.log('products are', newProducts)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => {
          console.log("res.data", res.data)
          toast.success('Product added to cart')
        })
        .catch(err => console.log("err", err))
      } else if(cartProduct[0].cartQuantity < product.quantity) {
        let newProducts = []
        dispatch(addToCart(product))
        const currentProducts = JSON.parse(localStorage.getItem("cartItems"))
        currentProducts.map(product => {
          newProducts.push({productId: product._id, quantity: product.cartQuantity})
        })
        console.log("Cart id", cart._id)
        updateCart({_id: cart._id, products: newProducts}, { 
          headers: {
            'Token': `Bearer ${user?.accessToken}`
          }
        })
        .then(res => toast.success('Product added to cart'))
        .catch(err => console.log("err", err))
      } else {
        toast("You hitted our max stock for this product")
      }
    } else {
      toast.error("Please log in or register", {
        position: "bottom-left",
    })
    }
  }


const handleColorChange = (event) => {
  // setValue(event.target.value)
  // console.log("event", event.target.value)
}



const renderMobileSingleProduct = () => (
  <Root>
  {(Object.keys(product).length > 0 ? (
  <>
    <div style={{textAlign: 'center'}}>
      <Button variant="contained" style={{width: "200px", textAlign: 'center', fontSize: '12px'}} onClick={() => navigate(-1)}>Back to smartphones</Button>
    </div>
    <div className="flexCenter" style={{padding: '20px', height: 'calc(100% - 56px)' }}>
        <Card style={{padding: '20px', display: 'flex', justifyContent: 'center', alignItems: 'center', flexDirection: 'column'}}>
        <Typography gutterBottom variant="h5" component="h2">
          {product.title}
        </Typography>
        <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '225px', height: '225px', objectFit:'cover', objectPosition:'center center'}}/>
        <div>
        <CardContent>
            <div>
              <Typography gutterBottom variant="h6" component="h4">
                Price: ${product.price}
              </Typography>
            </div>
            <Typography dangerouslySetInnerHTML={{ __html: product.desc }} variant="body2" color="textSecondary" component="p" />
          </CardContent>
          {!isLoading &&
          <FormControl>
              <FormLabel id="demo-controlled-radio-buttons-group">Colors</FormLabel>
              <RadioGroup
                aria-labelledby="demo-radio-buttons-group-label"
                row
                value={value}
                onChange={handleColorChange}
                name="radio-buttons-group">
                {data?.filter((prod) => {
                      return ((prod.groupId === product.groupId) && (prod.isActive === true))
                    }).map((prod) => (
                      <FormControlLabel value={colorsObj[prod.colorId]} onClick={() => changeProduct(prod._id)} control={<Radio />} label={colorsObj[prod.colorId]} />
                ))}
              </RadioGroup>
          </FormControl>
          }
          <div className="btns">
            <Button variant="contained" className="addToCartBtn" style={{fontSize: '12px', width: '125px', margin:'15px 0'}} onClick={() => handleAddToCart(product)} startIcon={<AddShoppingCart />} size="small" color="secondary" id="submitBtn" type="submit">
              Add to cart
            </Button>
          </div>
        </div>
        </Card>
      </div>
  </>
    ) :        
    <div style={{display: 'flex', justifyContent: 'center', alignItems: 'center', height: 'calc(100vh - 110px)'}}>   
      <ClipLoader
        color="#93032E"
        loading={Object.keys(product).length === 0}
        size={150}
        aria-label="Loading Spinner"
        data-testid="loader"
      />
    </div>
  )}
  </Root>
)


const renderTabletSingleProduct = () => (
  <Root>
  <div style={{textAlign: 'center'}}>
    <Button variant="contained" style={{width: "200px", textAlign: 'center'}} onClick={() => navigate(-1)}>Back to smartphones</Button>
  </div>
  <div className="flexCenter" style={{padding: '20px', height: 'calc(100% - 56px)' }}>
      <Card style={{padding: '20px', display: 'flex'}}>
      <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '300px', height: '300px', objectFit:'cover', objectPosition:'center'}}/>
      <div>
      <CardContent>
          <div>
            <Typography gutterBottom variant="h5" component="h2">
              {product.title}
            </Typography>
            <Typography gutterBottom variant="h5" component="h2">
              ${product.price}
            </Typography>
          </div>
          <Typography dangerouslySetInnerHTML={{ __html: product.desc }} variant="body2" color="textSecondary" component="p" />
        </CardContent>
        <div className="btns">
          <Button variant="contained" className="addToCartBtn" onClick={() => handleAddToCart(product)} startIcon={<AddShoppingCart />} size="small" color="secondary" id="submitBtn" type="submit">
            Cart
          </Button>
          <Button variant="contained" startIcon={<ShoppingBasketIcon />} size="small" color="secondary" id="submitBtn" type="submit" onClick={() => navigate("/")}>
              Shop
          </Button>
        </div>
      </div>
      </Card>
    </div>
</Root>
)


const renderDesktopSingleProduct = () => (
  <div style={{width:'1200px', margin:'110px auto', height:'100vh'}}>
    <Card sx={{display:'flex', padding:'30px'}}>
    <Image cloudName="deqqgmfxk"  publicId={product.img} style={{width: '400px', height: '400px', objectFit:'cover', objectPosition:'center'}}/>
    <div style={{width:'500px', marginLeft:'50px', display:'flex', justifyContent: 'space-between', flexDirection:'column'}}>
    <CardContent>
        <div>
          <Typography gutterBottom variant="h5" component="h1" sx={{fontWeight:'bold'}}>
            {product.title}
          </Typography>
          <Typography gutterBottom variant="h5" component="h1" sx={{fontWeight:'bold'}}>
            ${product.price}
          </Typography>
        </div>
        <div style={{marginBottom:'10px'}}>
          <Typography variant="subtitle1" sx={{fontWeight:'bold'}}>Description</Typography>
          <Typography dangerouslySetInnerHTML={{ __html: product.desc }} variant="subtitle1" color="textSecondary" component="p" />
        </div>
        <div style={{marginBottom:'10px'}}>
          {!isLoading &&
            <FormControl>
                <Typography variant="subtitle1" sx={{fontWeight:'bold'}}>Colors</Typography>
                <RadioGroup
                  aria-labelledby="demo-radio-buttons-group-label"
                  row
                  value={value}
                  onChange={handleColorChange}
                  name="radio-buttons-group">
                  {data?.filter((prod) => {
                        return ((prod.groupId === product.groupId) && (prod.isActive === true))
                      }).map((prod) => (
                        <FormControlLabel value={colorsObj[prod.colorId]} onClick={() => changeProduct(prod._id)} control={<Radio />} label={colorsObj[prod.colorId]} />
                  ))}
                </RadioGroup>
        </FormControl>}
        </div>
        </CardContent>
        <CardContent>
          <Button variant="contained" className="addToCartBtn" style={{width:'200px'}} onClick={() => 
            {
              handleAddToCart(product)
            }} 
            startIcon={<AddShoppingCart />} color="secondary" type="submit">
            Cart
          </Button>
        </CardContent>
    </div>
    </Card>
    <div>
    <h1 style={{textAlign:'center', marginTop:'70px'}}>Related Products</h1>
    <RelatedProductsSlider handleAddToCart={handleAddToCart}/>
    </div>

  </div>
)


return (
  <div>
      {
      (isXs) ?  renderMobileSingleProduct() : 
      (isSm) ? renderMobileSingleProduct() :
      (isMd) ? renderTabletSingleProduct() :
      renderDesktopSingleProduct()
    }
  </div>
);
};

export default GetProduct;